import { useMutation } from '@apollo/client';
import { useCallback } from 'react';

import { ConfirmUserHereWithUserIdMutation } from '../../apollo/__generated__/graphql';
import {
  CONFIRM_USER_HERE_WITH_CODE,
  CONFIRM_USER_HERE_WITH_USER_ID,
} from '../graphql/mutation/confirmUserHereMutation.graphql';
import { useCurrentEventQuery } from './useCurrentEventQuery';

export const useConfirmUserHereMutation = (
  onUserConfirmed: (
    user: ConfirmUserHereWithUserIdMutation['confirmUserHere'],
  ) => void,
  onError: () => void,
) => {
  const { data: currentEvent } = useCurrentEventQuery();
  const [mutateWithCode] = useMutation(CONFIRM_USER_HERE_WITH_CODE, {
    onCompleted: ({ confirmUserHere }) => onUserConfirmed(confirmUserHere),
    onError,
  });
  const [mutateWithUserId] = useMutation(CONFIRM_USER_HERE_WITH_USER_ID, {
    onCompleted: ({ confirmUserHere }) => onUserConfirmed(confirmUserHere),
    onError,
  });

  const confirmUserHere = useCallback(
    (params: { code: string } | { userId: string }) => {
      const eventId = currentEvent?.currentEvent?.id;
      if (!eventId) {
        return;
      }

      if ('code' in params) {
        mutateWithCode({
          variables: {
            code: params.code,
            eventId,
          },
        });
      } else {
        mutateWithUserId({
          variables: {
            userId: params.userId,
            eventId,
          },
        });
      }
    },
    [mutateWithCode, mutateWithUserId, currentEvent],
  );

  return { confirmUserHere };
};
